"use client";
import { useRouter } from "next/navigation";
import Image from "next/image";
import Ic_arrow_right_s from "@/app/assets/search/ic_arrow_right_s@2x.png";
import Tips_null from "@/app/assets/search/tips_null@2x.png";
import { PageResult } from "../../common";

export type SearchItemResultProps = {
    itemData?: any;
    isShowNoData?: boolean;
};

export const SearchItemResult: React.FC<SearchItemResultProps> = ({
    itemData,
    isShowNoData = false,
    ...props
}) => {
    const router = useRouter();

    const goSearchDetail = (link: string) => {
        if (link) {
            const urls = link.split(process.env.NEXT_PUBLIC_DOMAIN_URL || 'https://askpaul.ai/');
            if (urls.length > 1) router.push(`/${urls[1]}`);
        }
        // if (link) window.open(link, '_blank');
    }

    return (
        <>
            {
                itemData && itemData.map((item: any, index: number) => {
                    return <div onClick={() => goSearchDetail(item?.eventLink)} className={`flex justify-between py-15 items-center ${index < itemData.length - 1 ? 'border-b border-b-[#ffffff10]' : ''}`} key={index}>
                        <div className="flex items-center gap-10">
                            <Image
                                loading="lazy"
                                src={item?.image}
                                alt="Icon"
                                width={44}
                                height={44}
                            />
                            <div>
                                <div className="text-15 text-white font-bold">{item?.question || ''}</div>
                                <div className="flex items-center text-13 text-[#ffffff50] ">
                                    <div>{item?.parentTag?.label || ''}</div>
                                    <Image src={Ic_arrow_right_s} alt="Ic_arrow_right_s" width={15} height={15} />
                                    <div>{item?.childTag?.label || ''}</div>
                                </div>
                            </div>
                        </div>
                        <div className="text-bravve-100 font-bold text-15">{item?.outcome1Probability}%</div>
                    </div>
                })
            }
            {
                isShowNoData && itemData && itemData.length <= 0 && <div className="mt-15">
                    <PageResult
                        title="No Results Found"
                        sub=""
                        img={Tips_null}
                    />
                </div>
            }
        </>
    );
};